<template>
  <div class="w-100">
    <div class="row mt-4">
      <div class="col-12">
        <notes :object-id="$route.params.id" :api-key="apiKey"></notes>
      </div>
    </div>
  </div>
</template>

<script>

import Notes from "../../crm-notes/Notes";
export default {
  components: {Notes},
  data() {
    return {
      notes: null
    }
  },
  computed: {
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    },
    player: function () {
      return this.$store.getters["players/player"];
    },
  },
  mounted() {
  },
  watch: {},
  methods: {

  }
}
</script>
